/* VoluFine · vidéos témoignages : 17/10 (Malone) lecture automatique, sans le son, en boucle, dès qu'une vidéo est à l'écran ;
   elle se met en pause quand elle sort de l'écran. Un appui la met en pause ou la relance ; le rond « lecture » disparaît pendant la lecture. */
(function(){
  function play(v){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
  function init(root){
    if(!root||root.dataset.ready)return; root.dataset.ready='1';
    var vids=[].slice.call(root.querySelectorAll('[data-vf13-video]'));
    vids.forEach(function(v){
      var frame=v.parentNode, btn=frame.querySelector('[data-vf13-play]');
      v.muted=true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('autoplay','');
      v.addEventListener('play',function(){ if(btn)btn.classList.add('is-playing'); });
      v.addEventListener('pause',function(){ if(btn)btn.classList.remove('is-playing'); });
      frame.addEventListener('click',function(){ if(v.paused){ v.dataset.user=''; play(v); } else { v.dataset.user='pause'; v.pause(); } });
    });
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target;
        if(e.isIntersecting){ if(v.dataset.user!=='pause'){ if(v.preload==='none')v.preload='auto'; play(v); } }
        else if(!v.paused)v.pause(); }); },{threshold:.35});
      vids.forEach(function(v){ io.observe(v); });
    } else vids.forEach(play);
  }
  function all(){ [].slice.call(document.querySelectorAll('[data-vf13]')).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
